import internshala from "../images/internshala.png";
import milaap from "../images/milaap.png";
import zoomcar from "../images/zoomcar.png";
import jiosaavn from "../images/jiosaavn.png";

export const projects = [
  {
    image: zoomcar,
    title: "Zoomcar Backend and UI Clone",
    tech: "HTML | CSS | JavaScript | MongoDB | Node | Express | Mongoose",
    code: "https://github.com/Pulkit0111/project_zoomcar.git",
    demo: "https://drive.google.com/file/d/1XvHY5ozEsO-N1uU5s59-Yr5lFA2wAY1q/view?usp=sharing",
    des: "This project is a Full-Stack Clone of the well-known car rental platform Zoomcar, which includes the functionality of booking a car in a city of your choice.",
    dep: "https://pulkit0111.github.io/project_zoomcar/",
  },
  {
    image: jiosaavn,
    title: "JioSaavn Music Streaming Clone",
    tech: "React | Mock-Server",
    code: "https://github.com/Sabareesh-Subramanian/JioSaavn_Clone.git",
    demo: "https://drive.google.com/file/d/1dVw7bWxbZByXDcYy47M3CoV_fHvtDhTW/view",
    des: "This Project was done with the intention of making a pixel perfect clone of well-known music streaming platform JioSaavn along with music searching and playing functionality",
    dep: "https://jiosaavn-sabareesh.vercel.app/",
  },
  {
    image: milaap,
    title: "Milaap UI Clone",
    tech: "React | Mock-Server",
    code: "https://github.com/bharadwaj-bhat/Project_milaap.git",
    demo: "https://drive.google.com/file/d/1JxKO9WNH4xa3LEdZvlPAIK2YI8VxZQdg/view?usp=sharing",
    des: "Clone of Milaap.org, a humanitarian site that lets users raise money for different causes and as well as donate for other's.",
    dep: "https://bharadwaj-bhat.github.io/Project_milaap/",
  },
  {
    image: internshala,
    title: "Internshala UI Clone",
    tech: "HTML | CSS | JavaScript",
    code: "https://github.com/Pulkit0111/internshala_project.git",
    demo: "https://drive.google.com/file/d/14Bmsi6bemoSf6lTWMMERVg0bAde7CC2v/view?usp=sharing",
    des: "This repository has the UI clone of Internshala.com, which is a popular Ed-Tech Platform, where a fresher can go and apply for internships and jobs.",
    dep: "https://pulkit0111.github.io/internshala_project/",
  },
];
